import styled, { Attrs } from 'styled-components'

import {
    DisplaySize,
    DisplayWeight,
    DISPLAY_SIZE_STYLES,
    DISPLAY_WEIGHT_STYLES
} from '@/constants/styles/typography/display'

export type DisplayProps = {
    size?: DisplaySize
    weight?: DisplayWeight
} & Attrs

export const Display = styled.div.attrs<DisplayProps>(({ size, weight }) => ({
    className: ['display', size, weight].join(' ')
}))`
    ${({ size }: DisplayProps) => DISPLAY_SIZE_STYLES[size!]}
    ${({ weight }: DisplayProps) => DISPLAY_WEIGHT_STYLES[weight!]}
`

Display.defaultProps = {
    size: 'md',
    weight: 'medium'
}
